import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import { loadContingentList, monitoringModule } from '../MonitoringDucks';
import { contingentColumns } from './ContingentColumns';
import ExportFile from './ExportFile';

export default function MonitoringContingent() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { filter, nextPage } = useTableFilter(
    filter => {
      dispatch(loadContingentList(filter));
    },
    {
      pageNumber: 1,
      pageSize: 25
    }
  );
  const data = useSelector(state => state[monitoringModule].contingentList);
  const loading = useSelector(state => state[monitoringModule].loading);

  return (
    <div>
      <Box className="flex justify-end mb2">
        <ExportFile filter={filter} />
      </Box>
      <StaticTablePagination
        loading={loading}
        sortable={false}
        columns={contingentColumns({
          t,
          lang: i18n.language
        })}
        data={data.content}
        totalElements={data.totalElements}
        onClickLoadMore={() => nextPage()}
      />
    </div>
  );
}
